import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Modal, message, Button, Icon, Input } from 'antd';
import _get from 'lodash/get';

import Tabs from '../../components/Tab';
import Overview from './Overview';
import Domain from './Domain';
import Manage from './Manage';
import Events from './Events';
import SEOSetup from './SeoSetup';
import Metrics from './Metrics';
import Logs from './Logs';
import { SetupAction, ExchangeAction, ConstantAction } from '../../actions';
import { getFeeData, updateCloud, putExchange, getJob, getExchange, requestLogs, requestBackup, getIframeUrl } from '../../common/fetch';
import { getTabParams } from '../../common/utils';
import { Rive } from '../RiveComponent/index';
import {
    CLOUD_ICON,
    VERIFICATION_TICK_ICON,
    CLOSE_TERMINATE_ICON,
    EXCHANGE_SWITCH_ICON,
} from '../../config/media';
import { ConfirmationWrapper } from './style';

class Hosting extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isVisible: false,
            tabParams: getTabParams(),
            isOpen: false,
            type: 'requirement-pending',
            repo: {},
            isActive: true,
            isActiveLoading: false,
            isConfirmDisabled: true,
            isRequestDisabled: false,
            isLogs: false,
            isBackup: false,
            step: 1,
            isLogsDisabled: false,
            isBackupDisabled: false,
        }
    }

    componentDidMount() {
        this.getData();
        if (this.props.exchange) {
            this.setState({
                isVisible: this.props.exchange.type !== 'DIY',
                isActive: this.props.exchange.active
            });
        }
        if (_get(this.props.exchange, 'info.repository')) {
            this.setState({
                repo: {
                    url: _get(this.props.exchange, 'info.repository.url'),
                    branch: _get(this.props.exchange, 'info.repository.branch')
                }
            });
        }
        this.handleUpdateTab(this.props && this.props.exchange && this.props.exchange.type)
    }

    componentDidUpdate(prevProps) {
        const tabParams = getTabParams();
        if (JSON.stringify(this.props.location) !== JSON.stringify(prevProps.location) &&
            JSON.stringify(tabParams) !== JSON.stringify(this.state.tabParams)) {
            this.setState({ tabParams });
        }
        if (JSON.stringify(this.props.exchange) !== JSON.stringify(prevProps.exchange)) {
            this.setState({ isVisible: this.props.exchange.type !== 'DIY', isActive: this.props.exchange.active });
            if (JSON.stringify(_get(this.props.exchange, 'info.repository'))
                !== JSON.stringify(_get(prevProps.exchange, 'info.repository'))) {
                this.setState({
                    repo: {
                        ...this.state.repo,
                        url: _get(this.props.exchange, 'info.repository.url'),
                        branch: _get(this.props.exchange, 'info.repository.branch')
                    }
                });
            }
        }
    }

    getData = async () => {
        await this.getConstant();
        await this.getJob();
    };

    getConstant = async () => {
        try {
            const res = await getFeeData();
            if (res.data) {
                this.props.setConstant(res.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    handleTab = (value) => {
        this.setState({ isVisible: value });
    };

    handleTabChange = (key) => {
        this.setState({ tabParams: { ...this.state.tabParams, tab: key } });
    };

    handleLive = () => {
        const { exchange = {} } = this.props;
        const connectionStatus = exchange.domain && exchange.url && (exchange.is_paid || exchange.is_trial);
        this.setState({
            isOpen: true,
            type: connectionStatus
                ? 'goLive-confirm'
                : 'requirement-pending'
        });
    };

    handleClose = () => {
        this.setState({ isOpen: false, isConfirmDisabled: true });
    };

    handleNavigate = () => {
        this.props.history.push('/hosting?tab=0');
    };

    handleNavigateMetrics = () => {
        const { exchange } = this.props;
        this.props.history.push(`/hosting?tab=${exchange && exchange.type === 'Cloud' ? '6' : '2'}`);
    };

    handleNavigateLogs = () => {
        const { exchange } = this.props;
        this.props.history.push(`/hosting?tab=${exchange && exchange.type === 'Cloud' ? '5' : '1'}`);
    };

    handleNavigateGoLive = (type) => {
        type && type === "Cloud" ? this.props.history.push('/hosting?tab=3') : this.props.history.push('/billing');
    };

    handleCloud = async (type = 'setup', confirmType, callback) => {
        const { exchange } = this.props;
        localStorage.setItem("isEventStart", true);
        this.setState({ isRequestDisabled: true })
        try {
            await updateCloud({
                exchange_id: exchange.id
            }, {
                type
            });
            if (type === 'terminate') {
                message.error("Exchange is getting terminated");
            }
            if (type === 'start') {
                message.success("Exchange is starting...");
            }
            if (type === 'stop') {
                message.success("Exchange Stop in Progress...");
            }
            await this.getJob();
            await this.getExchange();
            if (confirmType) {
                this.setState({ type: confirmType });
            }
            if (callback) {
                callback();
            }
            setTimeout(() => {
                this.setState({ isRequestDisabled: false })
            }, 2000);
        } catch (error) {
            this.setState({ isActive: this.props.exchange.active });
            setTimeout(() => {
                this.setState({ isRequestDisabled: false })
            }, 2000);
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleVersion = () => {
        this.setState({ isOpen: true, type: 'version-confirm' });
        localStorage.setItem("isEventStart", true);
    };

    handleRestart = () => {
        this.setState({ isOpen: true, type: 'restart-confirm' });
    };

    handleCustomize = () => {
        this.setState({ isOpen: true, type: 'customize-confirm' });
    };

    handleTextChange = (e) => {
        this.setState({
            repo: {
                ...this.state.repo,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOff = async (checked) => {
        // this.setState({ isActiveLoading: true });
        // if (!checked) {
        this.setState({
            isOpen: true,
            type: 'exchange-state',
            isActive: checked
        });
        // } else {
        //     await this.handleCloud('start', '', () => { this.setState({ isActive: checked }) });
        //     this.setState({ isActiveLoading: false });
        // }
    };

    handleStopExchange = async () => {
        this.setState({ isActiveLoading: true });
        let type = this.state.isActive ? 'start' : 'stop';
        await this.handleCloud(
            type,
            '',
            () => { }
        );
        this.setState({ isActiveLoading: false, type });
    };

    handleTerminate = () => {
        this.setState({ isOpen: true, type: 'pre-terminate' });
    };

    getJob = async () => {
        const { exchange } = this.props;
        try {
            const res = await
                getJob(exchange.id);
            if (res.data) {
                this.props.readEventData({ events: res.data.data });
            }
        } catch (error) {
            console.error(error);
        }
    };

    putExchange = async () => {
        const { exchange } = this.props;
        try {
            let params = {
                id: exchange.id,
                info: {
                    repository: {
                        url: this.state.repo.url,
                        branch: this.state.repo.branch
                    }
                }
            }
            await putExchange(params);
            await this.getExchange();
            const link = document.createElement('a');
            link.href = 'https://github.com/apps/hollacloud/installations/new';
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(error);
        }
    };

    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            this.props.storeExchange(exchange);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };

    handleBilling = () => {
        this.handleClose();
        // this.props.setNewPay({ isNewPay: true });
        this.props.history.push('/billing');
    };

    handleExchangeState = () => {
        this.setState({ type: 'exchange-state-confirm' });
        localStorage.setItem("isEventStart", true);
    };

    handleInput = (e) => {
        let isConfirmDisabled = this.state.isConfirmDisabled;
        if (e.target.value === "I UNDERSTAND") {
            isConfirmDisabled = false;
        } else {
            isConfirmDisabled = true;
        }
        this.setState({ isConfirmDisabled });
    };

    handleBackup = async () => {
        const { exchange } = this.props;
        this.setState({ isBackupDisabled: true })
        try {
            let res = await requestBackup(exchange.id);
            if (res) {
                this.handleOpen("backup");
                localStorage.setItem("startTime", Date.now());
            }
            setTimeout(() => {
                this.setState({ isBackupDisabled: false })
            }, 2000);
        } catch (error) {
            console.error(error);
            if (error && error.data) {
                message.error(error.data.message)
            }
            setTimeout(() => {
                this.setState({ isBackupDisabled: false })
            }, 2000);
        }
    }

    handleLogs = async (start_date, end_date) => {
        const { exchange } = this.props;
        this.setState({ isLogsDisabled: true })
        const params = {
            start_date,
            end_date
        }
        try {
            let res = await requestLogs(exchange.id, params);
            if (res) {
                this.handleStep(2);
            }
            setTimeout(() => {
                this.setState({ isLogsDisabled: false })
            }, 2000);
        } catch (error) {
            console.error(error);
            if (error && error.data) {
                message.error(error.data.message)
            }
            setTimeout(() => {
                this.setState({ isLogsDisabled: false })
            }, 2000);
        }
        localStorage.setItem("isEventStart", true);
    }

    handleStep = (step) => {
        this.setState({ step });
    };

    handleOpen = (type) => {
        if (type === "logs") {
            this.setState({ isLogs: true });
        } else {
            this.setState({ isBackup: true });
            localStorage.setItem("isEventStart", true);
        }
    }

    handleCancel = () => {
        this.setState({ isLogs: false, isBackup: false, step: 1 });
    };

    renderConfirmationContent = () => {
        const { exchange = {} } = this.props;
        switch (this.state.type) {
            case 'start':
                return (
                    <ConfirmationWrapper>
                        <div>
                            <div className='image-wrapper events-animation-wrapper'>
                                <Rive src={'start.riv'} />
                            </div>
                            <div className="title">Starting exchange...</div>
                            <div className='pt-15'>Your exchange is starting. This may take a minute on average.</div>
                            <div className='pt-15'>Click the button below to view a historic record of your exchange's hosting events.</div>
                            <div className='pt-15'>
                                <Link to="/hosting?tab=4">
                                    <Button
                                        type="primary"
                                        onClick={() => this.setState({ isOpen: false })}
                                        className="w-100"
                                    >
                                        Go to events
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </ConfirmationWrapper>
                )
            case 'stop':
                return (
                    <ConfirmationWrapper>
                        <div>
                            <div className='image-wrapper events-animation-wrapper'>
                                <Rive src={'stop.riv'} />
                            </div>
                            <div className="title">Stopping exchange...</div>
                            <div className='pt-15'>Your exchange is stopping. This may take a minute on average.</div>
                            <div className='pt-15'>Click the button below to view a historic record of your exchange's hosting events.</div>
                            <div className='pt-15'>
                                <Link to="/hosting?tab=4">
                                    <Button
                                        type="primary"
                                        onClick={() => this.setState({ isOpen: false })}
                                        className="w-100"
                                    >
                                        Go to events
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </ConfirmationWrapper>
                )
            case 'pre-terminate':
                return (
                    <ConfirmationWrapper className="terminate-wrapper">
                        <div className="flex-content content-wrapper flex-column text-center">
                            <img src={CLOSE_TERMINATE_ICON} alt="terminate" className="close-terminate-icon" />
                            <div className="title">Terminate exchange</div>
                            <div className="content-wrapper">
                                Terminating your exchange will have irreversible consequences.
                            </div>
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" className="close-btn" onClick={() => this.handleClose()}>Close</Button>
                            <div className="divider"></div>
                            <Button
                                type="primary"
                                className="proceed-btn"
                                onClick={() => this.setState({ type: 'terminate' })}
                            >
                                Proceed
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'terminate':
                return (
                    <ConfirmationWrapper className="terminate-wrapper">
                        <div className="flex-content content-wrapper">
                            <div className="cloud_icon">
                                <Icon type="exclamation-circle" style={{ fontSize: '42px', color: '#ffffff' }} />
                            </div>
                            <div className="title">Terminate exchange</div>
                        </div>
                        <div className="content-wrapper content-description">
                            Terminating your exchange will permanently delete your exchange and all configurations. Use only when advised to do so by your cloud provider.
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" className="close-btn" onClick={() => this.setState({ type: 'pre-terminate' })}>Back</Button>
                            <div className="divider"></div>
                            <Button
                                type="primary"
                                className="proceed-btn"
                                onClick={() => this.setState({ type: 'terminate-confirm' })}
                            >
                                Proceed
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'terminate-confirm':
                return (
                    <ConfirmationWrapper className="terminate-wrapper">
                        <div className="flex-content content-wrapper align-content-top">
                            <div className="cloud_icon">
                                <Icon type="exclamation-circle" style={{ fontSize: '42px', color: '#ffffff' }} />
                            </div>
                            <div>
                                <div className="title">Terminate exchange</div>
                                <div className="content-wrapper">
                                    Please acknowledge that you understand the ramifications of terminating your exchange.
                                </div>
                            </div>
                        </div>
                        <div className="understand-input-wrapper">
                            <div>Type 'I UNDERSTAND' to confirm</div>
                            <Input onChange={this.handleInput} />
                        </div>
                        <div className="btn-wrapper">
                            <Button
                                type="primary"
                                className="close-btn flex"
                                onClick={() => this.setState({ type: 'terminate' })}
                            >
                                Close
                            </Button>
                            <div className="divider"></div>

                            <Button
                                type="primary"
                                className="proceed-btn"
                                disabled={this.state.isConfirmDisabled || this.state.isRequestDisabled}
                                onClick={() => {
                                    this.handleCloud(
                                        'terminate',
                                        '',
                                        this.handleNavigate
                                    );
                                }}
                            >
                                I understand. Proceed.
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'exchange-state':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content content-wrapper flex-column text-center">
                            <img src={EXCHANGE_SWITCH_ICON} alt="exchange state" className="close-terminate-icon" />
                        </div>
                        <div className="title text-center">
                            Change exchange state
                        </div>
                        <div className="content-wrapper text-center">
                            Changing the state of your exchange key may disrupt your live exchange and is an action that can have consequences.
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={this.handleClose}>Back</Button>
                            <div className="divider"></div>
                            <Button type="primary" disabled={this.state.isRequestDisabled} onClick={this.handleExchangeState}>I understand. Proceed.</Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'exchange-state-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content content-wrapper align-content-top">
                            <div className="cloud_icon">
                                <Icon type="exclamation-circle" style={{ fontSize: '42px', color: '#0000FF' }} />
                            </div>
                            <div>
                                <div className="title">
                                    {this.state.isActive
                                        ? "Turn exchange on"
                                        : "Turn exchange off"
                                    }
                                </div>
                                <div className="content-wrapper">
                                    {this.state.isActive
                                        ? "Are you sure you want to turn your exchange on? "
                                        : "Are you sure you want to turn your exchange off? "
                                    }
                                    This will make your exchange accessible.
                                </div>
                            </div>
                        </div>
                        <div className="content-wrapper">
                            <Button
                                type="primary"
                                onClick={() => this.setState({ type: 'turn-off-confirm' })}
                            >
                                Proceed
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'turn-off-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="title">Changing exchange state</div>
                        <div className="content-wrapper">
                            Please acknowledge that you understand the possible ramifications of changing the state of your exchange
                        </div>
                        <div className="understand-input-wrapper">
                            <div>Type 'I UNDERSTAND' to confirm</div>
                            <Input onChange={this.handleInput} />
                        </div>
                        <div className="btn-wrapper">
                            <Button
                                type="primary"
                                onClick={() => this.setState({ type: 'exchange-state-confirm' })}
                            >
                                Close
                            </Button>
                            <div className="divider"></div>
                            <Button
                                type="primary"
                                disabled={this.state.isConfirmDisabled || this.state.isRequestDisabled}
                                onClick={this.handleStopExchange}
                            >
                                I understand. Proceed.
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'customize-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="title">
                            Customize repo
                        </div>
                        <div className="content-wrapper">If you want to customize your exchange you can point your own git repo through this wizard. To learn more you can visit <a target="blank" href="https://docs.hollaex.com/">docs.hollaex.com.</a></div>
                        <div className="content-wrapper">Are you sure you want to continue?</div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={this.handleClose}>Back</Button>
                            <div className="divider"></div>
                            <Button
                                type="primary"
                                onClick={() => this.setState({ type: 'customize-repo' })}
                            >
                                Next
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'customize-repo':
                return (
                    <ConfirmationWrapper>
                        <div className="title">
                            Customize repo
                        </div>
                        <div className="content-wrapper">Repo URL should contain a protocol (https), and should end with '.git'</div>
                        <div className="content-wrapper">
                            <div className="content-title">Repo URL</div>
                            <Input
                                name="url"
                                placeholder="ex-forever-0.hollaex.com"
                                onChange={this.handleTextChange}
                                defaultValue=""
                                value={this.state.repo.url}
                            />
                        </div>
                        <div className="content-wrapper">
                            <div className="content-title">Repo branch</div>
                            <Input
                                name="branch"
                                placeholder="ex-forever-0.hollaex.com"
                                onChange={this.handleTextChange}
                                defaultValue=""
                                value={this.state.repo.branch}
                            />
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={() => this.setState({ type: 'customize-confirm' })}>Back</Button>
                            <div className="divider"></div>
                            <Button type="primary" onClick={this.putExchange}>Connect</Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'permission':
                return (
                    <ConfirmationWrapper>
                        <div className="title">
                            Provide permission
                        </div>
                        <div className="content-wrapper">To complete custom git setup you must provide permission to reach your git repo. Follow the steps below to complete the process:</div>
                        <div className="content-wrapper">
                            <li>
                                <ol>1. Go to the 'Settings' - 'Manage access' page of your private HollaEx Kit GitHub repository.</ol>
                                <ol>2. Click the 'Invite a collaborator' button, and invite the 'tech@bitholla.com' account.</ol>
                                <ol>3. Hold until the HollaEx team approves the request.</ol>
                            </li>
                        </div>
                        <div className="content-wrapper">
                            For more info visit: <a target="blank" href="https://docs.hollaex.com/">docs.hollaex.com</a>
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={() => this.setState({ type: 'customize-repo' })}>Back</Button>
                            <div className="divider"></div>
                            <Button type="primary" onClick={this.handleClose}>Done</Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'restart-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content content-wrapper">
                            <div className="cloud_icon">
                                <Icon type="exclamation-circle" style={{ fontSize: '42px', color: '#0000FF' }} />
                            </div>
                            <div className="title">Restart your exchange</div>
                        </div>
                        <div className="content-wrapper">
                            While restarting your exchange will be inaccessible. Restarting may take a few moments (5 minutes on average)
                        </div>
                        <div className="content-wrapper todo-list-wrapper">
                            Are you sure you want to restart your exchange?
                        </div>
                        <div className="content-wrapper">
                            <Button
                                type="primary"
                                disabled={this.state.isRequestDisabled}
                                onClick={() => {
                                    this.handleCloud('restart', 'restart')
                                }}
                            >
                                Proceed
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'restart':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content events-animation-wrapper-restart">
                            <Rive src={'restart.riv'} />
                        </div>
                        <div className="title">
                            Restarting exchange...
                        </div>
                        <div className="content-wrapper">Your exchange is restarting. This may take 5 minutes on average. Once your exchange has finished restarting you will be sent an email.</div>
                        <div className="content-wrapper">Click the button below to view a historic record of your exchange's hosting events.</div>
                        <div className="content-wrapper">
                            <Link to="/hosting?tab=4">
                                <Button type="primary" onClick={this.handleClose}>Go to events</Button>
                            </Link>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'version-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content content-wrapper">
                            <div className="cloud_icon">
                                <Icon type="exclamation-circle" style={{ fontSize: '42px', color: '#3A4FFF' }} />
                            </div>
                            <div className="title">Going live with your cloud exchange</div>
                        </div>
                        <div className="content-wrapper">
                            While upgrading your exchange will be inaccessible. Upgrading may take a few moments (30 minutes on average)
                        </div>
                        <div className="content-wrapper todo-list-wrapper">
                            Are you sure you want to proceed with the upgrade procedure?
                        </div>
                        <div className="content-wrapper">
                            <Button
                                disabled={this.state.isRequestDisabled}
                                type="primary"
                                onClick={() => {
                                    this.handleCloud('upgrade', 'version-upgrade')
                                }}
                            >
                                Proceed
                            </Button>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'version-upgrade':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content events-animation-wrapper">
                            <Rive src={'upgrade.riv'} />
                        </div>
                        <div className="title">
                            Upgrading exchange...
                        </div>
                        <div className="content-wrapper">Your exchange is getting upgraded. This may take 30 minutes on average. Once your exchange has finished upgrading you will be sent an email.</div>
                        <div className="content-wrapper">Click the button below to view a historic record of your exchange's hosting events.</div>
                        <div className="content-wrapper">
                            <Link to="/hosting?tab=4">
                                <Button type="primary" onClick={this.handleClose}>Go to events</Button>
                            </Link>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'exit-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className="flex-content">
                        </div>
                        <div className="title">
                            Building your cloud exchange...
                        </div>
                        <div className="content-wrapper">Your cloud exchange is getting setup. This may take 30 minutes on average. Once your exchange is live you will be sent an email.</div>
                        <div className="content-wrapper">Click the button below to view the status and historic record of your exchange's hosting events.</div>
                        <div className="content-wrapper">
                            <Link to="/hosting?tab=4">
                                <Button type="primary" onClick={this.handleClose}>Go to events</Button>
                            </Link>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'goLive-confirm':
                return (
                    <ConfirmationWrapper>
                        <div className='events-animation-wrapper-golive'>
                            <Rive src={'goLive.riv'} />
                            <div className="flex-content content-wrapper">
                                <div className="title">Going live with your cloud exchange</div>
                            </div>
                            <div className="content-wrapper">
                                Going live with your cloud exchange may take a few moments (30 minutes on average).
                            </div>
                            <div className="content-wrapper todo-list-wrapper">
                                Do you want to go live?
                            </div>
                            <div className="content-wrapper">
                                <Button disabled={this.state.isRequestDisabled} type="primary" onClick={() => this.handleCloud('setup', 'exit-confirm')}>Go live</Button>
                            </div>
                        </div>
                    </ConfirmationWrapper>
                );
            case 'requirement-pending':
            default:
                return (
                    <ConfirmationWrapper>
                        <div>
                            <span className="title">Going live with your cloud exchange</span>
                        </div>
                        <div className="flex-content content-wrapper flex-container">
                            <img src={CLOUD_ICON} className="cloud_icon" alt="cloud_icon" />
                            <div>
                                <span className="content-title">Hosting type:</span>{' '}
                                {exchange.type}
                            </div>
                        </div>
                        <div className="content-wrapper">
                            In order to make your exchange live with your domain you must complete your to do list below:
                        </div>
                        <div className="content-wrapper todo-list-wrapper">
                            <div className="content-title">To do list:</div>
                            <div className="todo-list">
                                {(exchange.domain && exchange.url)
                                    ? <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                    : <Icon
                                        type="minus-circle"
                                        theme="filled"
                                        style={{ fontSize: '12px', color: '#F28041' }}
                                    />
                                }
                                <span className="list-text">Connect your own domain</span>{' '}
                                <Link to="/hosting?tab=1" onClick={this.handleClose}>(View)</Link>
                            </div>
                            <div className="todo-list">
                                {exchange.region
                                    ? <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                    : <Icon
                                        type="minus-circle"
                                        theme="filled"
                                        style={{ fontSize: '12px', color: '#F28041' }}
                                    />
                                }
                                <span className="list-text">Set server region</span>{' '}
                                <Link to="/hosting?tab=3" onClick={this.handleClose}>(View)</Link>
                            </div>
                            <div className="todo-list">
                                {exchange.is_paid
                                    ? <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                    : <Icon
                                        type="minus-circle"
                                        theme="filled"
                                        style={{ fontSize: '12px', color: '#F28041' }}
                                    />
                                }
                                <span className="list-text">Pay pending bill</span>{' '}
                                <Link onClick={this.handleBilling}>(View)</Link>
                            </div>
                            <div className="todo-list">
                                {exchange.is_signed ?
                                    <>
                                        <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                                        <span className="list-text">Verified</span>{' '}
                                    </>
                                    :
                                    <>
                                        <Icon
                                            type="minus-circle"
                                            theme="filled"
                                            style={{ fontSize: '12px', color: '#F28041' }}
                                        />
                                        <span className="list-text">Verification</span>{' '}
                                        <Link to="/verifyAgree">(View)</Link>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="content-wrapper">
                            <Button type="primary" onClick={this.handleClose}>Back</Button>
                        </div>
                    </ConfirmationWrapper>
                );
        }
    };

    handleUpdateTab = (type) => {
        if (type === 'Cloud') {
            this.setState({ tabParams: { tab: "3" } })
        } else {
            this.setState({ tabParams: { tab: "0" } })
        }
    }

    getIframeData = async () => {
        return await getIframeUrl(this.props && this.props.exchange && this.props.exchange.id)
    }

    render() {
        const { tabParams, isOpen, type, isLogs, isBackup, step, isLogsDisabled, isBackupDisabled } = this.state;
        const { exchange, actions, storeExchange, constant, history } = this.props;
        const HostingTabList = [
            {
                key: 'overview',
                name: 'Overview',
                path: '/overview',
                isVisible: true,
                content: (
                    <Overview
                        exchange={exchange}
                        storeExchange={storeExchange}
                        actions={actions}
                        constant={constant}
                        handleTab={this.handleTab}
                        handleLive={this.handleLive}
                        getEvents={this.getJob}
                        handleUpdateTab={this.handleUpdateTab}
                    />
                )
            },
            {
                key: 'domain',
                name: 'Domain',
                path: '/domain',
                isVisible: this.state.isVisible,
                content: <Domain handleCloud={this.handleCloud} history={this.props.history} />
            },
            {
                key: 'seo',
                name: 'SEO',
                path: '/seo',
                isVisible: this.state.isVisible,
                content: <SEOSetup history={this.props.history} />
            },
            {
                key: 'manage',
                name: 'Manage',
                path: '/manage',
                isVisible: this.state.isVisible,
                content: (
                    <Manage
                        exchange={exchange}
                        constant={constant}
                        getEvents={this.getJob}
                        handleLive={this.handleLive}
                        handleVersion={this.handleVersion}
                        handleRestart={this.handleRestart}
                        handleCustomize={this.handleCustomize}
                        handleOff={this.handleOff}
                        handleTerminate={this.handleTerminate}
                        isLogs={isLogs}
                        isBackup={isBackup}
                        step={step}
                        handleBackup={this.handleBackup}
                        handleStep={this.handleStep}
                        handleCancel={this.handleCancel}
                        handleLogs={this.handleLogs}
                        handleOpen={this.handleOpen}
                        isLogsDisabled={isLogsDisabled}
                        isBackupDisabled={isBackupDisabled}
                        history={history}
                        getExchange={this.getExchange}
                    />
                )
            },
            {
                key: 'events',
                name: 'Events',
                path: '/events',
                isVisible: this.state.isVisible,
                content: <Events getExchange={this.getExchange} />
            },
            {
                key: 'metrics',
                name: 'Metrics',
                path: '/metrics',
                isVisible: true,
                content: <Metrics getData={this.getIframeData} handleNavigateMetrics={this.handleNavigateMetrics} goLive={this.handleNavigateGoLive} type={exchange.type} props={this.props} />
            },
            {
                key: 'logs',
                name: 'Logs',
                path: '/logs',
                isVisible: true,
                content: <Logs getData={this.getIframeData} handleNavigateLogs={this.handleNavigateLogs} goLive={this.handleNavigateGoLive} type={exchange.type} props={this.props} />
            }
        ]
        let tabUtils = HostingTabList.filter(tabs => tabs.isVisible === true)
        return (
            <>
                <div className="main-header">
                    Hosting
                </div>
                <Tabs TabList={tabUtils} activeTab={tabParams.tab} onChange={this.handleTabChange} isExchangeExpired={this.props.constant.isExchangeExpired} />
                <Modal
                    visible={isOpen}
                    footer={null}
                    width={`460px`}
                    onCancel={this.handleClose}
                    bodyStyle={{
                        padding: '0px',
                    }}
                    wrapClassName={
                        type.includes('terminate')
                            ? "terminate-modal-wrapper"
                            : ""
                    }
                >
                    {this.renderConfirmationContent()}
                </Modal>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
    constant: state.constant
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(SetupAction, dispatch),
    storeExchange: bindActionCreators(ExchangeAction.readData, dispatch),
    setConstant: bindActionCreators(ConstantAction.readData, dispatch),
    readEventData: bindActionCreators(ConstantAction.readEventData, dispatch),
    // setNewPay: bindActionCreators(BillingAction.setNewInvoice, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Hosting);
